module.exports = __webpack_public_path__ + "img/4.26c8bff3.svg";